import {Contact} from "../interfaces";

export function displayContact(u: Contact): string|null {
  if (u.name != "" && u.companyName != "") return `${u.name} (${u.companyName})`;
  if (u.name != "") return u.name;
  if (u.companyName != "") return u.companyName;
  return null;
}
